module.exports = __webpack_public_path__ + "img/sulv_7.05c00481.jpg";